import request from './request';
// 查询是否存在激活奖励
export const isExitReward = () =>
    request({
      url: '/reward/activation',
      method: 'GET'
    });
  
// 领取激活奖励
export const receiveReward = data =>
    request({
      url: '/reward/activation',
      method: 'POST',
      data
    });